import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import CaretUp16 from '@carbon/icons-react/es/caret--up/16';
import StarReview20 from '@carbon/icons-react/es/star--review/20';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Task } from 'api/tasks';
import { Collapse, Panel, PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';
import styles from '../overview.module.css';
import { CsatList } from './csat-list';

interface CsatProps {
  data?: Task[];
  onSubmit: () => void;
}

export const Csat: FC<CsatProps> = (props) => {
  const { data = [], onSubmit } = props;
  const [csatPanelOpened, setCsatPanelOpened] = useState(true);

  const onToggle = (key) => {
    const isCollapseMenuOpen = String(key) === 'csat';

    setCsatPanelOpened(isCollapseMenuOpen);
  };

  return data.length > 0 ? (
    <Collapse
      key="list"
      className={styles.collapse}
      ghost
      defaultActiveKey="csat"
      expandIconPosition="right"
      onChange={onToggle}
      expandIcon={({ isActive }) => {
        return isActive ? <CaretUp16 /> : <CaretDown16 />;
      }}
    >
      <Panel
        key="csat"
        showArrow
        header={
          <PanelHeaderTitle
            icon={<IconShell size="large" icon={<StarReview20 />} />}
            title={<FormattedMessage id="rate_your_experience" />}
          />
        }
      >
        <CsatList
          csatPanelOpened={csatPanelOpened}
          data={data}
          onSubmit={onSubmit}
        />
      </Panel>
    </Collapse>
  ) : null;
};
